export const fakeTable = [
  {
    user: 'Juana Piaggio',
    date: '20/10/23 17:28:32',
    userId: '608d7453a7d2e',
    operations: ['authentication', 'teseo', 'onboarding'],
  },
  {
    user: 'Pedro Sanchez',
    date: '21/10/23 14:45:19',
    userId: '608d7453a7d2e',
    operations: ['authentication'],
  },
  {
    user: 'Luisa Martinez',
    date: '22/10/23 09:12:56',
    userId: '608d7453c4e7f',
    operations: ['teseo'],
  },
  {
    user: 'Carlos Rodriguez',
    date: '23/10/23 16:30:45',
    userId: '608d7453e1f82',
    operations: ['onboarding', 'authentication'],
  },
  {
    user: 'Ana Fernandez',
    date: '24/10/23 11:20:10',
    userId: '608d7453fe964',
    operations: ['teseo'],
  },
  {
    user: 'Marta Lopez',
    date: '25/10/23 13:55:27',
    userId: '608d745411b9c',
    operations: ['authentication'],
  },
  {
    user: 'Javier Garcia',
    date: '26/10/23 08:17:33',
    userId: '608d745426dcd',
    operations: ['teseo', 'onboarding'],
  },
  {
    user: 'Elena Perez',
    date: '27/10/23 19:03:14',
    userId: '608d74543bf4e',
    operations: ['teseo'],
  },
  {
    user: 'Raúl Ramirez',
    date: '28/10/23 22:14:05',
    userId: '608d74544e5eb',
    operations: ['onboarding', 'authentication'],
  },
  {
    user: 'Isabel Gonzalez',
    date: '29/10/23 10:40:21',
    userId: '608d74545f90a',
    operations: ['teseo'],
  },
  {
    user: 'Sergio Morales',
    date: '30/10/23 15:27:50',
    userId: '608d745470cc3',
    operations: ['authentication'],
  },
  {
    user: 'Lucia Torres',
    date: '31/10/23 07:52:38',
    userId: '608d745482196',
    operations: ['teseo', 'onboarding'],
  },
  {
    user: 'Pablo Fernández',
    date: '01/06/21 18:09:47',
    userId: '608d7454935d1',
    operations: ['teseo', 'authentication'],
  },
  {
    user: 'Laura Diaz',
    date: '02/06/21 09:30:14',
    userId: '608d7454a48a9',
    operations: ['teseo'],
  },
  {
    user: 'Manuel Castro',
    date: '03/06/21 14:15:22',
    userId: '608d7454b5bdf',
    operations: ['onboarding'],
  },
  {
    user: 'Carmen Ruiz',
    date: '04/06/21 12:05:09',
    userId: '608d7454c6f6c',
    operations: ['authentication', 'teseo'],
  },
  {
    user: 'Roberto Lopez',
    date: '05/06/21 16:45:30',
    userId: '608d7454d827b',
    operations: ['teseo'],
  },
  {
    user: 'Maria Ramos',
    date: '06/06/21 20:18:57',
    userId: '608d7454e9a1e',
    operations: ['onboarding', 'authentication'],
  },
  {
    user: 'Antonio Jimenez',
    date: '07/06/21 11:36:42',
    userId: '608d7454faf0a',
    operations: ['teseo'],
  },
  {
    user: 'Sofia Silva',
    date: '08/06/21 07:10:25',
    userId: '608d74550cbe3',
    operations: ['authentication'],
  },
];

export const fakeUserInformation = {
  Name: 'SOFÍA',
  Surname: 'REYES CAMPOS',
  Nationality: 'ESP',
  'Document nr.': '71579781D',
  'Date of birth': '03/05/1990',
  'City of birth': 'BUENOS AIRES',
  Address: 'CALLE ANTIGUA 2 P03 AK',
  City: 'ALICANTE',
  Mobil: '+34 652 19 87 26',
  Mail: 'eduardoperez@facephi.com',
};

export const fakeInteractions = [
  {
    authentication: 'Credit card order',
  },
  {
    onboarding: 'Christmas raffle',
  },
  {
    authentication: 'Mortgage',
  },
  {
    onboarding: 'Document sign',
  },
];

export const fakeCustomerTable = [
  {
    date: '20/10/23 17:28:32',
    status: 'EXPIRED',
    operations: 'authentication',
  },
  {
    date: '21/10/23 14:45:19',
    status: 'EXPIRED',
    operations: 'authentication',
  },
  {
    date: '22/10/23 09:12:56',
    status: 'EXPIRED',
    operations: 'teseo',
  },
  {
    date: '23/10/23 16:30:45',
    status: 'SUCCEEDED',
    operations: 'onboarding',
  },
  {
    date: '24/10/23 11:20:10',
    status: 'SUCCEEDED',
    operations: 'teseo',
  },
  {
    date: '25/10/23 13:55:27',
    status: 'EXPIRED',
    operations: 'authentication',
  },
  {
    date: '26/10/23 08:17:33',
    status: 'EXPIRED',
    operations: 'teseo',
  },
  {
    date: '27/10/23 19:03:14',
    status: 'SUCCEEDED',
    operations: 'teseo',
  },
  {
    date: '28/10/23 22:14:05',
    status: 'SUCCEEDED',
    operations: 'onboarding',
  },
  {
    date: '29/10/23 10:40:21',
    status: 'EXPIRED',
    operations: 'teseo',
  },
];

export const fakePrivacyTable = [
  {
    date: '18.04.2021',
    operations: 'Rectification of record',
    code: '6278h65ty',
    agent: 'Eduardo Perez',
    email: 'edupere@fin.com',
    status: 'PENDING',
  },
  {
    date: '18.04.2021',
    operations: 'Deletion of record',
    code: '6278h65ty',
    agent: 'Eduardo Perez',
    email: 'edupere@fin.com',
    status: 'PENDING',
  },
  {
    date: '18.04.2021',
    operations: 'Record information',
    code: '6278h65ty',
    agent: 'Eduardo Perez',
    email: 'edupere@fin.com',
    status: 'PENDING',
  },
  {
    date: '18.04.2021',
    operations: 'Record information',
    code: '6278h65ty',
    agent: 'Eduardo Perez',
    email: 'edupere@fin.com',
    status: 'SUCCEEDED',
  },
  {
    date: '18.04.2021',
    operations: 'Deletion of record',
    code: '6278h65ty',
    agent: 'Eduardo Perez',
    email: 'edupere@fin.com',
    status: 'SUCCEEDED',
  },
  {
    date: '18.04.2021',
    operations: 'Rectification of record',
    code: '6278h65ty',
    agent: 'Eduardo Perez',
    email: 'edupere@fin.com',
    status: 'SUCCEEDED',
  },
  {
    date: '18.04.2021',
    operations: 'Rectification of record',
    code: '6278h65ty',
    agent: 'Eduardo Perez',
    email: 'edupere@fin.com',
    status: 'SUCCEEDED',
  },
  {
    date: '18.04.2021',
    operations: 'Deletion of record',
    code: '6278h65ty',
    agent: 'Eduardo Perez',
    email: 'edupere@fin.com',
    status: 'SUCCEEDED',
  },
  {
    date: '18.04.2021',
    operations: 'Record information',
    code: '6278h65ty',
    agent: 'Eduardo Perez',
    email: 'edupere@fin.com',
    status: 'SUCCEEDED',
  },
  {
    date: '18.04.2021',
    operations: 'Rectification of record',
    code: '6278h65ty',
    agent: 'Eduardo Perez',
    email: 'edupere@fin.com',
    status: 'SUCCEEDED',
  },
];
